import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loadingUser } = useAuth();

  if (loadingUser) {
    return null; // or spinner later
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const role = String(user.role || "").toLowerCase();

  if (
    allowedRoles &&
    !allowedRoles.map((r) => r.toLowerCase()).includes(role)
  ) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;